export default __webpack_public_path__ + "static/econverse-31c7843bfa99821994ea62d922cfa8db.png";